import axios from 'axios';
import Cookies from 'js-cookie';

// API-Instanz erstellen
const api = axios.create({
    baseURL: 'https://hch.it-brb.app',
    withCredentials: true, // Wichtig für die Verwendung von Cookies
});

// Interceptor für die automatische Token-Erneuerung bei 401-Fehlern
api.interceptors.response.use(
    response => response,
    async error => {
        const originalRequest = error.config;

        // Wenn die Antwort 401 Unauthorized ist und es nicht bereits ein erneuter Versuch war
        if (error.response && error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                // Verwende den HttpOnly-Refresh-Token, um einen neuen Access Token zu erhalten
                const {data} = await axios.post('https://hch.it-brb.app/api/v1/token', {}, {
                    withCredentials: true // Der Refresh Token wird automatisch gesendet
                });

                // Überprüfe, ob ein neuer Access-Token erfolgreich empfangen wurde
                if (data.accessToken) {
                    // Speichern des neuen Access Tokens als Cookie
                    Cookies.set('accessToken', data.accessToken, {
                        secure: true,
                        sameSite: 'None',
                        path: '/'
                    });

                    // Setze den neuen Access Token im Header der ursprünglichen Anfrage
                    originalRequest.headers['Authorization'] = 'Bearer ' + data.accessToken;

                    // Wiederhole die ursprüngliche Anfrage mit dem neuen Access Token
                    return api(originalRequest);
                } else {
                    console.error('Kein Access Token erhalten');
                    return Promise.reject(error);
                }
            } catch (refreshError) {
                console.error('Token-Erneuerung fehlgeschlagen, Benutzer wird ausgeloggt');
                Cookies.remove('accessToken', {path: '/'});
                window.location.href = '/login';
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);

export default api;
